import * as Yup from 'yup';

const validate = Yup.object().shape({
  description: Yup.object().shape({
    Dosage: Yup.string(),
    id: Yup.string(),
    name: Yup.string(),
    unitPrice: Yup.number(),
    uom: Yup.string(),
    vendor: Yup.string(),
  }),
  uomUnit: Yup.string().required('This field is required'),
  amountPerTime: Yup.number().when('useCustomInstruction', {
    is: false,
    then: Yup.number()
      .typeError('This field must be number')
      .required('This field is required')
      .min(0.1, 'Dosage must be greater than or equal to 0.1'),
  }),
  quantity: Yup.number().typeError('This field must be number').required('This field is required'),
  // .max(999, 'Quantity must be greater than or equal to 999'),
  // quantity: Yup.number().typeError('This field must be number').when('useCustomInstruction', {
  //   is: false,
  //   then: Yup.number().required('This field is required')
  //     .max(999, 'Quantity must be greater than or equal to 999'),
  // }),
  doseUnit: Yup.string().when('useCustomInstruction', {
    is: false,
    then: Yup.string().required('This field is required'),
  }),
  frequency: Yup.string().when('useCustomInstruction', {
    is: false,
    then: Yup.string().required('This field is required'),
  }),
  note: Yup.string().when('useCustomInstruction', {
    is: true,
    then: Yup.string().required('This field is required'),
    otherwise: Yup.string().max(500, 'Note should be less than or equal to 500 characters'),
  }),
  // quantity: Yup.number()
  //   .required('This field is required')
  //   .max(999, 'Quantity must be greater than or equal to 999'),
  // dosageUnit: Yup.string()
  //   .required('This field is required'),
  // .min(Yup.ref('amountPerTime'), 'Quantity must be greater than or equal to dosage'),
  // timesPerTimeUnit: Yup.number()
  //   .required('This field is required')
  //   .min(1, 'Frequency must be greater than or equal to 1')
  //   .max(99, 'Frequency must be less than or equal to 99'),
  // timesPerTimeUnit: Yup.string()
  //   .required('This field is required'),
  // note: Yup.string()
  //   .max(500, 'Note should be less than or equal to 500 characters'),
});

export default validate;
